<template>
  <div class="page-container">
    <div class="my">
      <!-- 头部背景 -->
      <div class="home-wrapper"></div>
      <div class="user">
        <div class="left">
          <img src="@/assets/img/tabs/5.png" class="user-logo"/>
          <i class="user-text">超级管理移动后台</i>
        </div>
        <div class="right" @click="jumpcuAccountInfo">
          <img src="@/assets/img/my/edit.png" class="user-logo"/>
          <i class="user-text">登录/退出</i>
        </div>
      </div>
      <div class="user-msg" @click.stop="jumpPassword">
        <div class="left">
          <img src="@/assets/img/my/user-logo.png" class="user-img" v-if="userinfo.avatar == null"/>
          <img :src="userinfo.avatar" class="user-img" v-else/>
          <div class="user-content">
            <div class="user-name">
              {{ store.name || '暂无' }}
              <i class="user-icon">&nbsp;</i>
            </div>
            <div class="user-reputation">
              <i>信誉:</i>
              <i class="level">{{ store.honestyName }}</i>
            </div>
          </div>
        </div>
        <div class="user-card">
          <img src="@/assets/img/my/card.png" class="card-img" alt/>
          名片
        </div>
      </div>


      <div class="content-box">
        <div class="user-body">
          <div class="box box-item" v-for="(item, index) in boxItems" :key="index">
            <div class="box-content" @click="navigate(item)">
              <img :src="item.icon" alt class="box-img"/>
              <i class="box-text">{{ item.text }}</i>
            </div>
          </div>
        </div>
      </div>
      <div class="user-foot">
        <div class="content" v-for="(item, index) in footItems" :key="index" @click="navigate(item)">
          <img :src="item.icon" alt class="content-img"/>
          <i class="content-text">{{ item.text }}</i>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import api from '../../utils/api'
import {aGet, aPost} from '../../utils/request'
import $ from 'jquery'
import {NavBar} from 'vant'
import {mapActions} from 'vuex'
import nfc from '../../utils/nfc.js'
import shopIcon from '@/assets/img/imprint/shop.png';
import downloadsIcon from '@/assets/img/my/downloads.png';
import addressIcon from '@/assets/img/my/address.png';
import editIcon from '@/assets/img/my/edit.png';
import serviceIcon from '@/assets/img/my/service.png';
import agreementIcon from '@/assets/img/my/agreement.png';
import peopleIcon from '@/assets/img/my/people.png';
import notepadIcon from '@/assets/img/my/Notepad.png';
import lotteryIcon from '@/assets/img/detail/lottery_icons.png';
import customerIcon from '@/assets/img/my/customer.png';
import scanIcon from '@/assets/img/my/scan.png';
import adIcon from '@/assets/img/my/ad.png';

import addIcon from '@/assets/img/my/add.png';
import invitationIcon from '@/assets/img/my/invitation.png';
import houseIcon from '@/assets/img/my/house.png';
export default {
  name: 'my',
  components: {},
  data() {
    return {
      id: JSON.parse(localStorage.getItem('id')),
      // 权限列表
      permissionsList: [],
      storeId: 0,
      powerStatus: undefined,
      userinfo: {},
      store: {},
      scan: null,
      codeUrl: '',
      footItems: [
        { icon: peopleIcon, text: '用户列表', path: '/resource/manager' },
        { icon: houseIcon, text: '店铺列表', path: '/downproducts' },
        { icon: invitationIcon, text: '新增用户', path: '/upproducts' },
      ],
      boxItems: [
        // { icon: shopIcon, text: '资源管理', path: '/resource/manager' },
        // { icon: downloadsIcon, text: '下载离线包', path: '/downproducts' },
        // { icon: downloadsIcon, text: '上传离线包', path: '/upproducts' },
        // { icon: addressIcon, text: '地址管理', path: '/Residence' },
        // { icon: editIcon, text: '登录/退出', path: '/accountInfo' },
        // { icon: serviceIcon, text: '已购服务', path: '/purchased' },
        // { icon: agreementIcon, text: '公告管理', path: '/Announcement' },
        // { icon: peopleIcon, text: '展台群', path: '/Group' },
        // { icon: notepadIcon, text: '记事本', path: '/Notepad' },
        // { icon: agreementIcon, text: '协议', path: '/agreement' },
        // { icon: lotteryIcon, text: '撞宝', path: '/Lottery' },
        // { icon: customerIcon, text: '客服', path: '/customer' },
        // { icon: editIcon, text: '名片设置', path: '/profile/store/info' },
        // { icon: agreementIcon, text: '缴费寄存', path: '/cuAddressBook' },
        // { icon: adIcon, text: '广告', path: '/Advertisement' },
        // { icon: notepadIcon, text: '链接管理', path: '/store/external-link' },
        // { icon: scanIcon, text: '扫一扫', path: '/scanformy' }
      ]
    }
  },
  methods: {
    navigate(item) {
      this.$router.push({ path: item.path });
    },
    // 展厅
    async jumpExhibition() {
      let obj = this.permissionsList.filter((item) => item.powerName == '展厅')
      let powerStatus = await this.getUserWhetherPurchaseStorePermissions(obj[0].id)
      console.log(123)
      // setTimeout( () => {
      if (this.powerStatus != undefined && this.powerStatus == false) {
        console.log('111')
        this.$toast('您暂无此权限,请先购买权限配置！')
        this.$router.push({
          path: '/buyservice'
        })
      } else if (this.powerStatus != undefined && this.powerStatus == true) {
        console.log('2222')
        this.$router.push({
          path: '/Exhibition'
        })
      }
      // },300)
    },

    async jumpShelfManager() {
      this.$router.push({
        path: '/shelf/manager',
        query: { storeId: this.storeId }
      })
    },

    async externalLinkManager() {
      this.$router.push({
        path: '/store/external-link'
      })
    },
    async resourceManager() {
      this.$router.push({
        path: '/resource/manager'
      })
    },
    ...mapActions(['setStoreId']),
    // 协议
    downproducts() {
      this.$router.push({
        path: '/downproducts'
      })
    },
    uploadproducts() {
      this.$router.push({
        path: '/upproducts'
      })
    },
    jumpPassword() {
      this.$router.push({
        path: '/changepassword'
      })
    },
    // 抽奖
    jumpLottery() {
      this.$router.push({
        path: '/Lottery?storeId=' + this.storeId
      })
    },
    // 账号信息
    jumpcuAccountInfo() {
      this.$router.push({
        path: '/accountInfo'
      })
    },

    // 美工
    async jumpartist() {
      let obj = this.permissionsList.filter((item) => item.powerName == '美工')
      let powerStatus = await this.getUserWhetherPurchaseStorePermissions(obj[0].id)
      // setTimeout( () => {
      if (this.powerStatus != undefined && this.powerStatus == false) {
        this.$toast('您暂无此权限,请先购买权限配置！')
        this.$router.push({
          path: '/buyservice'
        })
      } else if (this.powerStatus != undefined && this.powerStatus == true) {
        this.$router.push({
          path: '/artist'
        })
      }
      // },300)
    },
    // 我的
    jumpUser() {
      this.$router.push({
        path: '/profile/store/info'
      })
    },
    // 补货
    async jumpSupplement() {
      let obj = this.permissionsList.filter((item) => item.powerName == '补货')
      console.log('obj', obj)
      let powerStatus = await this.getUserWhetherPurchaseStorePermissions(obj[0].id)
      console.log(11)
      // setTimeout( () => {
      if (this.powerStatus != undefined && this.powerStatus == false) {
        this.$toast('您暂无此权限,请先购买权限配置！')
        this.$router.push({
          path: '/buyservice'
        })
      } else if (this.powerStatus != undefined && this.powerStatus == true) {
        this.$router.push({
          path: '/Supplement'
        })
      }
      // },300)
    },
    // 获取我的信息
    userMessage() {
      let parma = {
        id: this.id
      }
      aPost(api.getUserInfo, parma).then((res) => {
        console.log('我的信息', res)


        this.store = res.data.data.store
        this.storeId = res.data.data.store.id
        this.setStoreId(JSON.parse(this.storeId))
        localStorage.setItem('storeId', this.storeId)
        console.log('this.storeId', this.storeId)

        if (this.store.name == null) {
          this.store.name = '';
        }
        localStorage.setItem('type', this.store.storeIdentity)
        this.userinfo = res.data.data
        console.log('--------------', this.userinfo)
        console.log(this.store)
      })
    },
    // 获取全部店铺权限
    getAllStorePermissionsList() {
      aGet(api.getAllStorePermissionsList).then((res) => {
        console.log('全部店铺权限', res)
        this.permissionsList = res.data.data
        console.log('xxxx', this.permissionsList)
      })
    },
    // 查询用户是否购买功能权限
    async getUserWhetherPurchaseStorePermissions(id) {
      // return new Promise(reslove => {
      let parma = {
        storeId: this.storeId,
        powersId: id
      }
      console.log(parma)
      // let res = aGet(api.getUserWhetherPurchaseStorePermissions,parma)
      await aGet(api.getUserWhetherPurchaseStorePermissions, parma).then((res) => {
        this.powerStatus = res.data
        console.log('222', this.powerStatus)
      })

      // console.log('查询用户是否购买功能权限',res);

      // reslove(res.data)
      // })
    }
  },
  computed: {},
  created() {

    //底部导航栏定位
    this.$store.state.bmTab = 5
    nfc.listenNFCStatus()
    nfc.readData()
  },
  mounted() {
    this.userMessage()
    this.getAllStorePermissionsList()
  },
  watch: {
    $route: function (to, from, next) {
      console.log('1132', to.meta.keepAlive, to)
    }
  },
  updated() {
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/mixin';

.page-container {
  display: flex;
  flex-direction: column;
  min-height: 100vh; /* 确保容器至少占满整个视口高度 */
}

.my {
  display: flex;
  flex-direction: column; /* 垂直排列子元素 */
  flex: 1; /* 占据剩余空间 */

  background: #f2f5f3;
  // min-height: 100%;
  // min-width: 100%;
  // max-height: 100%;
  // height: 90%;
  height: 100vh;
  padding-bottom: 60px;

  .home-wrapper {
    width: 100%;
    height: 20%;
    background: url('../../assets/img/home/bc.png') center bottom no-repeat;
    background-size: cover;
    position: fixed;
    top: 50px;
    left: 0;
  }

  .user {


    position: relative;
    z-index: 1;
    display: inline-flex;
    // margin-left: 32px;
    // margin-top: 30px;
    width: 100%;
    justify-content: space-between;
    padding: 30px;
    padding-bottom: 0;

    .left {
      display: inline-flex;

      .user-logo {
        width: 40px;
        height: 40px;
      }

      .user-text {
        // width: 68px;
        // height: 34px;
        font-size: 34px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        // line-height: 46px;
        color: #000000;
        opacity: 1;
        margin-left: 16px;
        margin-top: -4px;
      }
    }

    .right {
      display: inline-flex;
      align-items: center;

      .user-logo {
        width: 40px;
        height: 40px;
      }

      .user-text {
        // width: 68px;
        // height: 34px;
        // height: 28px;
        line-height: 45px;
        font-size: 28px;
        font-family: Source Han Sans CN;
        opacity: 1;
        margin-left: 16px;
        margin-top: 0px;
      }
    }
  }

  .user-msg {
    padding: 0 32px;
    width: 686px;
    height: 160px;
    background: #ffffff;
    opacity: 1;
    border-radius: 20px;
    position: relative;
    z-index: 1;
    margin-top: 20px;
    margin-left: 32px;
    display: inline-flex;
    justify-content: space-between;

    .left {
      display: inline-flex;
      // padding-right: 40px;
    }

    .user-img {
      width: 96px;
      height: 96px;
      margin-top: 32px;
      // margin-left: 24px;
      border-radius: 50%;
    }

    .user-content {
      margin-left: 32px;
      margin-top: 38px;

      .user-name {
        display: inline-flex;
        font-size: 30px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        line-height: 51px;
        color: #222222;
      }

      .user-reputation {
        .level {
          font-size: 28px;
          font-family: Source Han Sans CN;
          font-weight: 500;
          color: #222222;
        }
      }
    }

    .user-card {
      width: 150px;
      height: 72px;
      background: #f2f5f3;
      opacity: 1;
      border-radius: 36px;
      display: inline-flex;
      margin-top: 37px;
      // margin-left: 140px;
      justify-content: center;
      align-items: center;

      .card-img {
        width: 40px;
        height: 40px;
        margin-right: 8px;
      }
    }
  }


  .content-box {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding: 20px;
  }

  .user-body {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }

  .box-item {
    width: 22%; /* 每个项目占 4 个元素一行 */
    margin-bottom: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding: 10px;
    background-color: #f5f5f5;
    border-radius: 15px;
  }

  .box-content {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    cursor: pointer;
  }

  .box-img {
    width: 60px;
    height: 60px;
  }

  .box-text {
    margin-top: 16px;
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #222222;
  }

  .user-foot {
    width: 686px;
    height: 163px;
    background: #fff;


    margin: 0 auto; /* 水平居中 */
    margin-top: auto; /* 将上边距设为自动，推到页面底部 */
    margin-bottom: 50px; /* 保持与 tFooter 的距离 */

    display: flex;
    border-radius: 20px;

    .content {
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;

      .content-img {
        width: 54px;
        height: 54px;
      }

      .content-text {
        font-size: 32px;
        font-family: Source Han Sans CN;
        font-weight: 600;
        margin-top: 15px;
        color: #222222;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/admin/Dashboard.vue